var map = {
	"./symbol_0.png": 49700,
	"./symbol_1.png": 5997,
	"./symbol_10.png": 93798,
	"./symbol_2.png": 24374,
	"./symbol_3.png": 4351,
	"./symbol_4.png": 53024,
	"./symbol_5.png": 24201,
	"./symbol_6.png": 33490,
	"./symbol_7.png": 31355,
	"./symbol_8.png": 93548,
	"./symbol_9.png": 85026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36140;